import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import ShellBrand from '../brand/ShellBrand';
import ShellNavLinks, { ShellProfileLinks } from './ShellNavLinks';
import NotificationCenter from './NotificationCenter';

const AppSidebar = ({
    isAdmin,
    canManageTasks,
    canAccessCoaching,
    logout,
    isDarkMode,
    toggleTheme,
    profileTaskBadge,
    reklamaceNotifBadge,
    newsUnreadBadge,
    collapsed,
    onToggleCollapse,
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = { isAdmin, canManageTasks, canAccessCoaching };

    return (
        <aside
            className={`app-sidebar ${collapsed ? 'app-sidebar--collapsed' : ''}`}
            aria-label="Hlavní navigace"
        >
            <div className="app-sidebar__brand">
                <ShellBrand showWordmark={!collapsed} />
                <button
                    type="button"
                    className="app-sidebar__collapse-btn"
                    onClick={onToggleCollapse}
                    title={collapsed ? 'Rozbalit menu' : 'Sbalit menu'}
                    aria-label={collapsed ? 'Rozbalit menu' : 'Sbalit menu'}
                >
                    <i className={`fas fa-chevron-${collapsed ? 'right' : 'left'}`} />
                </button>
            </div>

            <nav className="app-sidebar__nav">
                <ShellNavLinks
                    auth={auth}
                    location={location}
                    navigate={navigate}
                    collapsed={collapsed}
                    profileTaskBadge={profileTaskBadge}
                    reklamaceNotifBadge={reklamaceNotifBadge}
                    newsUnreadBadge={newsUnreadBadge}
                    linkClass="app-sidebar__link"
                    activeClass="app-sidebar__link--active"
                    childClass="app-sidebar__link--child"
                />
            </nav>

            <div className="app-sidebar__footer">
                <div className="app-sidebar__footer-row">
                    <div className="app-sidebar__profile-wrap">
                        <ShellProfileLinks
                            location={location}
                            navigate={navigate}
                            collapsed={collapsed}
                            linkClass="app-sidebar__link"
                            activeClass="app-sidebar__link--active"
                            childClass="app-sidebar__link--child"
                        />
                    </div>
                    <NotificationCenter collapsed={collapsed} />
                </div>
                <div className="app-sidebar__footer-row app-sidebar__footer-row--logout">
                    <button
                        type="button"
                        className="app-sidebar__link app-sidebar__link--logout"
                        onClick={logout}
                        title={collapsed ? 'Odhlásit' : undefined}
                    >
                        <i className="fas fa-sign-out-alt" aria-hidden="true" />
                        {!collapsed && <span className="shell-nav__label">Odhlásit</span>}
                    </button>
                    <button
                        type="button"
                        className="app-sidebar__icon-btn"
                        onClick={toggleTheme}
                        title={isDarkMode ? 'Světlý režim' : 'Tmavý režim'}
                    >
                        <i className={`fas ${isDarkMode ? 'fa-sun' : 'fa-moon'}`} />
                    </button>
                </div>
            </div>
        </aside>
    );
};

export default AppSidebar;
